import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=d6ff48a4"
import script from "./fields.js?vue&type=script&lang=js&external"
export * from "./fields.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports